import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { catchError, finalize, tap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { SubscriptionConfig } from '../../model/v3/subscriptions';
import {
  ToastNotification,
  ToastNotificationsService,
} from '../../services/toast-notifications.service';
import { SubscriptionsV3RestService } from '../../services/rest/v3/subscriptions-rest.service';

@Component({
  selector: 'app-admin-school-subscriptions',
  templateUrl: './admin-school-subscriptions.component.html',
  standalone: false,
})
export class AdminSchoolSubscriptionsComponent implements OnInit {
  schoolId: number;

  config: SubscriptionConfig | null = null;
  configSaving = false;
  configError: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private subscriptionsRest: SubscriptionsV3RestService,
    private toastService: ToastNotificationsService,
  ) {}

  ngOnInit(): void {
    this.route.parent.paramMap
      .pipe(
        tap((params) => (this.schoolId = +params.get('schoolId'))),
      )
      .subscribe(() => this.loadConfig());
  }

  loadConfig() {
    this.subscriptionsRest
      .getConfig(this.schoolId)
      .pipe(tap((config) => (this.config = config)))
      .subscribe();
  }

  saveConfig() {
    if (!this.config) {
      return;
    }
    this.configSaving = true;
    this.configError = null;
    this.subscriptionsRest
      .updateConfig(this.schoolId, this.config)
      .pipe(
        tap((config) => {
          this.config = config;
          this.toastService.display(
            new ToastNotification('Subscription rules', 'Rules have been saved.'),
          );
        }),
        catchError((error) => {
          this.configError =
            error?.error?.message ?? 'Saving the subscription rules failed';
          return EMPTY;
        }),
        finalize(() => (this.configSaving = false)),
      )
      .subscribe();
  }
}
